import { Sheet } from 'react-modal-sheet';
import { Hide } from '@s20/components/common/Hide';
import './index.scss';

const defaultProps = {};

export const ActionSheet = ({
    ContainerProps = defaultProps,
    HeaderProps = defaultProps,
    ContentProps = defaultProps,
    children,
    ...restProps
}) => (
    <Hide smDown>
        <Sheet
            snapPoints={[0, 0.2, 0.75, 1]}
            initialSnap={2}
            {...restProps}
        >
            <Sheet.Container {...ContainerProps}>
                <Sheet.Header {...HeaderProps} />

                <Sheet.Content
                    style={{
                        maxHeight: 'calc(75dvh - 60px)',
                        overflowY: 'auto',
                    }}
                    {...ContentProps}
                >
                    {children}
                </Sheet.Content>
            </Sheet.Container>
        </Sheet>
    </Hide>
);